export function capitalize(value: string, locales?: Intl.LocalesArgument): string {
    return value.charAt(0).toLocaleUpperCase(locales) + value.slice(1);
}
